class @FieldVisibilityManager

  @setup: (field, elements, test, options) ->

    new @(field, elements, test, options)

  constructor: (field, elements, test, options) ->

    @$field    = $(field)
    @$elements = ($(element) for element in elements)
    @test      = test
    @animate   = false

    @$field.on("change", @adjustVisibility)
    @adjustVisibility()

    @animate   = true
    @options   = options || {}
    @animate   = false if @options["animate"] == false

  adjustVisibility: (e, options) =>

    animate = @animate && ( !options || options.animate != false )
    visible = @test(@currentValue())

    for $element in @$elements
      $inputs = $("input,textarea,select", $element)

      if $element.is(":visible") && !visible
        $element[if animate then "slideUp" else "hide"]()
        $inputs.attr(disabled: "disabled")
      else if !$element.is(":visible") && visible
        $inputs.removeAttr("disabled")
        $element[if animate then "slideDown" else "show"]()

  currentValue: =>

    if @$field.length > 1
      @$field.filter(":checked").val()
    else
      @$field.val()
